import { Product } from '@/domain/Product'
import axios from 'axios'

/**
 * 商品管理サービス
 */
export default class ProductsService {
    /** インスタンス */
    private static _instance: ProductsService

    /**
     * コンストラクタ
     */
    // eslint-disable-next-line
    private constructor() {}

    /**
     * インスタンスの取得
     */
    public static get instance() {
        if (!this._instance) {
            this._instance = new ProductsService();
        }
        return this._instance;
    }

    /**
     * 会社向け商品情報を取得
     * @param customerPrefectureCode
     * @param isNew
     */
    public async findByCustomer(customerPrefectureCode: string, customerCode: string): Promise<Product[]> {
        return await axios.get(`/api/products/${customerPrefectureCode}/${customerCode}`)
            .then((results) => {
                if (results.status === 200) {
                    return (results.data as Product[]).map(x => new Product({ ...x }))
                } else {
                    return []
                }
            })
            // eslint-disable-next-line
            .catch((error) => {
                return []
            })
    }
}
